import { memoize } from 'lodash';

import { labware } from './labware';
import type { LabwareDef, LabwareDefByDefURI } from './types';
import type { LabwareType } from '../types';

export const getLabwareURI = memoize((def: LabwareDef): string => {
  return `${def.namespace}/${def.loadName}`;
});

export const getAllLabwareDefinitions: () => LabwareDefByDefURI = memoize(
  (): LabwareDefByDefURI => {
    return labware.reduce<LabwareDefByDefURI>(
      (acc, def) => ({
        ...acc,
        [getLabwareURI(def)]: def,
      }),
      {}
    );
  }
);

export const getAllLabwareDefinitionsOfType: (
  labwareType: LabwareType
) => LabwareDef[] = memoize((labwareType: LabwareType): LabwareDef[] => {
  const result = labware.filter((def) => def.type === labwareType);
  return result.sort((a, b) => a.displayName.localeCompare(b.displayName));
});
